import { createContext, useState } from 'react'
import { useControleIlustracao } from '../hooks/useControleIlustracao'
import { useContext } from 'react'

export const ControleIlustracaoContext = createContext({})

export const ControleIlustracaoProvider = ({ children }) => {
  const [formValues, setFormValues] = useState({ pedido: '', compre_ganhe: null, modelo_arte: null })
  const [isCompreGanhe, setIsCompreGanhe] = useState(false)

  const { query, modelos, mutation } = useControleIlustracao(formValues)

  function handleCompreGanhe() {
    setIsCompreGanhe(true)
  }

  function cancelCompreGanhe() {
    setIsCompreGanhe(false)
  }

  return (
    <ControleIlustracaoContext.Provider
      value={{ formValues, setFormValues, query, modelos, isCompreGanhe, handleCompreGanhe, cancelCompreGanhe, mutation }}
    >
      {children}
    </ControleIlustracaoContext.Provider>
  )
}

export const useControleIlustracaoContext = () => {
  const context = useContext(ControleIlustracaoContext)

  if (!context) {
    throw new Error('useControleIlustracaoContext must be used within a ControleIlustracaoProvider')
  }

  return context
}
